export async function getAvailableDevices() {
    if (!navigator?.mediaDevices?.enumerateDevices) {
        alert("Device selection not supported in this browser. Video call will use default audio and video devices.");
        return;
    }

    return await navigator.mediaDevices.enumerateDevices().catch(() => alert("Something went wrong"));
}

